// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__1HnB-","balanceDisclaimer":"posDashboard_balanceDisclaimer__1Lt11"};